import { Paper } from "@mui/material";
import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useRouter } from "next/router";
import * as constants from "../../Components/constants";

const SummaryPost = ({ isLoggedIn }) => {
  const baseURL = constants.BASE_URL;
  const router = useRouter();
  const groupID = router.query.keyword;

  //Local Storage Data State
  const [storeTitle, setStoreTitle] = useState("");
  const [storeObjective, setStoreObjective] = useState("");
  const [storeTheoretical, setStoreTheoretical] = useState("");
  const [storeGap, setStoreGap] = useState("");
  const [storeUniqueness, setStoreUniqueness] = useState("");
  const [storeData, setStoreData] = useState("");
  const [storeMethodology, setStoreMethodology] = useState("");
  const [storeResult, setStoreResult] = useState("");
  const [storeValidity, setStoreValidity] = useState("");
  const [storeUsefulness, setStoreUsefulness] = useState("");
  const [storeReference, setStoreReference] = useState("");
  const [storeAnnex, setStoreAnnex] = useState("");
  const [storeKeyword, setStoreKeyword] = useState("");

  const [file1, setFile1] = useState();
  const [file2, setFile2] = useState();

  const handle = () => {
    localStorage.setItem("storeTitle", storeTitle);
    localStorage.setItem("storeObjective", storeObjective);
    localStorage.setItem("storeTheoretical", storeTheoretical);
    localStorage.setItem("storeUniqueness", storeUniqueness);
    localStorage.setItem("storeData", storeData);
    localStorage.setItem("storeMethodology", storeMethodology);
    localStorage.setItem("storeResult", storeResult);
    localStorage.setItem("storeValidity", storeValidity);
    localStorage.setItem("storeGap", storeGap);
    localStorage.setItem("storeUsefulness", storeUsefulness);
    localStorage.setItem("storeReference", storeReference);
    localStorage.setItem("storeAnnex", storeAnnex);
    localStorage.setItem("storeKeyword", storeKeyword);
  };

  const handleSummaryPost = () => {
    // e.preventDefault();
    const newData = new FormData();

    newData.append("title_of_research_article", storeTitle);
    newData.append("objective_of_the_study", storeObjective);
    newData.append("theoritical_Background", storeTheoretical);
    newData.append("research_gap", storeGap);
    newData.append("uniqueness_of_the_study", storeUniqueness);
    newData.append("data_source_sample_information", storeData);
    newData.append("research_methodology", storeMethodology);
    newData.append("result_discussion", storeResult);
    newData.append("validity_reliability_of_finding", storeValidity);
    newData.append("usefulness_of_the_finding", storeUsefulness);
    newData.append("reference", storeReference);
    newData.append("annex", storeAnnex);
    newData.append("file1", file1 ? file1 : "");
    newData.append("file2", file2 ? file2 : "");
    newData.append("keyword", storeKeyword);
    groupID
      ? newData.append("group", groupID)
      : newData.append("user", localStorage.getItem("id"));

    fetch(
      `${baseURL}/post/${localStorage.getItem("id")}/user-summery-create/`,
      {
        method: "POST",
        headers: {
          Authorization: `Token ${localStorage.getItem("auth_token")}`,
        },
        body: newData,
      }
    )
      .then((res) => {
        if (res.status === 400) {
          alert("please enter all the required field");
        } else if (res.status === 201) {
          alert("successfully publish");
          router.push(`/user/${localStorage.id}`);
        }
      })
      .catch((error) => console.log(error));
  };

  React.useEffect(() => {
    if (!isLoggedIn) {
      router.replace("/user/login");
    }
  }, [isLoggedIn, router]);

  if (!isLoggedIn) {
    return null; // or a loading state if desired
  }

  return (
    <Container className="pt-5 mt-2" fluid>
      <Row className="justify-content-center">
        <Col md={8}>
          <Paper className="p-4">
            <form>
              <h5>Title of Research Article</h5>

              <div id="example-collapse-text">
                <Form.Group
                  onChange={(e) => setStoreTitle(e.target.value)}
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    defaultValue={
                      typeof window !== "undefined"
                        ? localStorage.getItem("storeTitle")
                        : ""
                    }
                    as="textarea"
                    rows={2}
                    placeholder="Title of Research Article"
                  />
                </Form.Group>
                <div className="text-end">
                  <Button onClick={handle} size="sm" variant="primary">
                    Save as a draft
                  </Button>
                </div>
              </div>

              {/* section-2 */}

              <h5>Objective of the Study</h5>

              <div id="example-collapse-text">
                <Form.Group
                  onChange={(e) => setStoreObjective(e.target.value)}
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    defaultValue={
                      typeof window !== "undefined"
                        ? localStorage.getItem("storeObjective")
                        : ""
                    }
                    as="textarea"
                    rows={6}
                    placeholder="Objective of the study"
                  />
                </Form.Group>
                <div className="text-end">
                  <Button size="sm" onClick={handle} variant="primary">
                    Save as a draft
                  </Button>
                </div>
              </div>

              {/* section-3 */}

              <h5>Theoretical Background</h5>

              <div id="example-collapse-text">
                <Form.Group
                  onChange={(e) => setStoreTheoretical(e.target.value)}
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    defaultValue={
                      typeof window !== "undefined"
                        ? localStorage.getItem("storeTheoretical")
                        : ""
                    }
                    as="textarea"
                    rows={6}
                    placeholder="Theoretical Background"
                  />
                </Form.Group>
                <div className="text-end">
                  <Button onClick={handle} size="sm" variant="primary">
                    Save as a draft
                  </Button>
                </div>
              </div>

              {/* section-4 */}

              <h5>Research Gap</h5>

              <div id="example-collapse-text">
                <Form.Group
                  onChange={(e) => setStoreGap(e.target.value)}
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    defaultValue={
                      typeof window !== "undefined"
                        ? localStorage.getItem("storeGap")
                        : ""
                    }
                    as="textarea"
                    rows={6}
                    placeholder="Research Gap"
                  />
                </Form.Group>
                <div className="text-end">
                  <Button onClick={handle} size="sm" variant="primary">
                    Save as a draft
                  </Button>
                </div>
              </div>

              {/* section-5 */}

              <h5>Uniqueness of the Study</h5>

              <div id="example-collapse-text">
                <Form.Group
                  onChange={(e) => setStoreUniqueness(e.target.value)}
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    defaultValue={
                      typeof window !== "undefined"
                        ? localStorage.getItem("storeUniqueness")
                        : ""
                    }
                    as="textarea"
                    rows={6}
                    placeholder="Uniqueness of the study"
                  />
                </Form.Group>
                <div className="text-end">
                  <Button onClick={handle} size="sm" variant="primary">
                    Save as a draft
                  </Button>
                </div>
              </div>

              {/* section-6 */}

              <h5>Data Source/Sample Information</h5>

              <div id="example-collapse-text">
                <Form.Group
                  onChange={(e) => setStoreData(e.target.value)}
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    defaultValue={
                      typeof window !== "undefined"
                        ? localStorage.getItem("storeData")
                        : ""
                    }
                    as="textarea"
                    rows={6}
                    placeholder="Data source/sample Information"
                  />
                </Form.Group>
                <div className="text-end">
                  <Button onClick={handle} size="sm" variant="primary">
                    Save as a draft
                  </Button>
                </div>
              </div>

              {/* section-7 */}

              <h5>Research Methodology</h5>

              <div id="example-collapse-text">
                <Form.Group
                  onChange={(e) => setStoreMethodology(e.target.value)}
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    defaultValue={
                      typeof window !== "undefined"
                        ? localStorage.getItem("storeMethodology")
                        : ""
                    }
                    as="textarea"
                    rows={6}
                    placeholder="Research methodology"
                  />
                </Form.Group>
                <div className="text-end">
                  <Button onClick={handle} size="sm" variant="primary">
                    Save as a draft
                  </Button>
                </div>
              </div>

              {/* section-8 */}

              <h5>Result & Discussion</h5>

              <div id="example-collapse-text">
                <Form.Group
                  onChange={(e) => setStoreResult(e.target.value)}
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    defaultValue={
                      typeof window !== "undefined"
                        ? localStorage.getItem("storeResult")
                        : ""
                    }
                    as="textarea"
                    rows={6}
                    placeholder="Result & discussion"
                  />
                </Form.Group>
                <div className="text-end">
                  <Button onClick={handle} size="sm" variant="primary">
                    Save as a draft
                  </Button>
                </div>
              </div>

              {/* section-9 */}

              <h5>Validity & Reliability of Finding</h5>

              <div id="example-collapse-text">
                <Form.Group
                  onChange={(e) => setStoreValidity(e.target.value)}
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    defaultValue={
                      typeof window !== "undefined"
                        ? localStorage.getItem("storeValidity")
                        : ""
                    }
                    as="textarea"
                    rows={6}
                    placeholder="Validity & reliability of finding"
                  />
                </Form.Group>
                <div className="text-end">
                  <Button onClick={handle} size="sm" variant="primary">
                    Save as a draft
                  </Button>
                </div>
              </div>

              {/* section-10 */}

              <h5>Usefulness of the Finding</h5>

              <div id="example-collapse-text">
                <Form.Group
                  onChange={(e) => setStoreUsefulness(e.target.value)}
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    defaultValue={
                      typeof window !== "undefined"
                        ? localStorage.getItem("storeUsefulness")
                        : ""
                    }
                    as="textarea"
                    rows={6}
                    placeholder="Usefulness of the finding"
                  />
                </Form.Group>
                <div className="text-end">
                  <Button onClick={handle} size="sm" variant="primary">
                    Save as a draft
                  </Button>
                </div>
              </div>

              {/* section-11 */}

              <h5>Reference</h5>

              <div id="example-collapse-text">
                <Form.Group
                  onChange={(e) => setStoreReference(e.target.value)}
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    defaultValue={
                      typeof window !== "undefined"
                        ? localStorage.getItem("storeReference")
                        : ""
                    }
                    as="textarea"
                    rows={6}
                    placeholder="Reference"
                  />
                </Form.Group>
                <div className="text-end">
                  <Button onClick={handle} size="sm" variant="primary">
                    Save as a draft
                  </Button>
                </div>
              </div>

              {/* section-12 */}

              <h5>Annex</h5>

              <div id="example-collapse-text">
                <Form.Group
                  onChange={(e) => setStoreAnnex(e.target.value)}
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    defaultValue={
                      typeof window !== "undefined"
                        ? localStorage.getItem("storeAnnex")
                        : ""
                    }
                    as="textarea"
                    rows={6}
                    placeholder="Annex"
                  />
                </Form.Group>
                <div className="text-end">
                  <Button onClick={handle} size="sm" variant="primary">
                    Save as a draft
                  </Button>
                </div>
              </div>

              {/* section-13 */}

              <h5>Uploaded File</h5>

              <div id="example-collapse-text">
                <Form.Group controlId="formFileSm" className="mb-3">
                  <Form.Control
                    type="file"
                    size="sm"
                    onChange={(e) => setFile1(e.target.files[0])}
                  />
                </Form.Group>
                <Form.Group controlId="formFileSm" className="mb-3">
                  <Form.Control
                    type="file"
                    size="sm"
                    onChange={(e) => setFile2(e.target.files[0])}
                  />
                </Form.Group>
              </div>

              {/* section-14 */}

              <h5>Keyword</h5>

              <div id="example-collapse-text">
                <Form.Group
                  onChange={(e) => setStoreKeyword(e.target.value)}
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Control
                    defaultValue={
                      typeof window !== "undefined"
                        ? localStorage.getItem("storeKeyword")
                        : ""
                    }
                    as="textarea"
                    rows={6}
                    placeholder="Keyword without space"
                  />
                </Form.Group>
                <div className="text-end">
                  <Button onClick={handle} size="sm" variant="primary">
                    Save as a draft
                  </Button>
                </div>
              </div>
            </form>
          </Paper>

          <div className=" py-2 text-end">
            <Button
              className="px-5 fw-bold"
              onClick={() => handleSummaryPost()}
              variant="success"
            >
              Publish
            </Button>
            <Form.Text className="d-block" muted>
              Publish your Research Article ,to choose the best fit for your
              research.
            </Form.Text>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

SummaryPost.getInitialProps = async () => {
  // Replace this with your actual authentication logic
  const isLoggedIn = false;

  return {
    isLoggedIn,
  };
};

export default SummaryPost;
